import baseAssignValue from "./component-library321.mjs";
import eq from "./component-library413.mjs";
function assignMergeValue(object, key, value) {
  if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}
export {
  assignMergeValue as default
};
